import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const incidentSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllIncident: builder.query({
            query: (params) => ({
                url: `IncidentTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Incident"],
        }),


        getSingleIncidentDetails: builder.query({
            query: ({ IncidentTracker, params }) => ({
                url: `IncidentTracker/${IncidentTracker}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createIncident: builder.mutation({
            query: ({ body }) => ({
                url: `IncidentTracker`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Incident"],
        }),

        updateIncident: builder.mutation({
            query: ({ body }) => ({
                url: `IncidentTracker`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Incident"],
        }),


        getAllIncidentCount: builder.query({
            query: (params) => ({
                url: `IncidentTracker/summary`,
                params,
            }),
            invalidatesTags: ["Incident"],
        }),
        getExportAllIncident: builder.query({
            query: (params) => ({
                url: `IncidentTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),



    }),
});

export const {
    useGetAllIncidentCountQuery,
    useCreateIncidentMutation,
    useLazyGetAllIncidentCountQuery,
    useUpdateIncidentMutation,
    useGetSingleIncidentDetailsQuery,
    useLazyGetAllIncidentQuery,
    useLazyGetExportAllIncidentQuery

} = incidentSlice;